import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TimeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Time",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.86 15.55c0-5.44-4.41-9.84-9.84-9.84s-9.85 4.41-9.85 9.84 4.41 9.84 9.84 9.84 9.84-4.41 9.84-9.84ZM17 9.65v5.9h3.94c.5.05.89.47.89.98s-.39.93-.89.98h-4.93c-.55 0-.99-.44-.99-.99V9.64c.05-.5.47-.89.98-.89s.93.39.98.89Zm6.67-6.72c-.22-.13-.48-.21-.77-.21-.53 0-1 .28-1.26.71-.13.22-.21.49-.21.77 0 .53.28.99.7 1.25 2.31 1.43 4.07 3.56 4.99 6.09l.03.08a1.477 1.477 0 0 0 2.85-.55c0-.16-.02-.31-.07-.45-1.18-3.25-3.37-5.91-6.19-7.65l-.06-.04ZM9.89 5.45a1.47 1.47 0 0 0 .49-2.03 1.5 1.5 0 0 0-1.27-.7c-.28 0-.55.08-.77.21-2.89 1.78-5.09 4.44-6.24 7.61l-.03.1c-.05.15-.08.31-.08.49 0 .82.66 1.48 1.48 1.48.64 0 1.19-.41 1.39-.98.95-2.62 2.71-4.76 4.97-6.15l.05-.03ZM25.7 25.24a1.477 1.477 0 1 0-2.64 1.33s.99 1.91.99 1.91a1.477 1.477 0 1 0 2.64-1.33s-.99-1.91-.99-1.91m-17.4-.66c-.19-.1-.42-.16-.66-.16-.58 0-1.07.33-1.32.81s-.99 1.97-.99 1.97a1.477 1.477 0 0 0 1.39 1.98c.53 0 .99-.28 1.25-.69s.99-1.97.99-1.97c.09-.18.14-.4.14-.63 0-.57-.32-1.06-.79-1.31Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.86 31.86c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16m0-29.72C8.3 2.14 2.15 8.29 2.15 15.85S8.3 29.56 15.86 29.56s13.71-6.15 13.71-13.71S23.42 2.14 15.86 2.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.57 22.71c-.29 0-.58-.11-.81-.33l-5.71-5.71c-.21-.21-.33-.5-.33-.81V5.57a1.14 1.14 0 1 1 2.28 0v9.81l5.38 5.38a1.14 1.14 0 0 1-.81 1.95"
      })]
    })
  }));
};
TimeIcon.displayName = 'TimeIcon';